export default __webpack_public_path__ + "static/media/5.b68e9a5c.jpg";